export const GET_ERROR_MESSAGE = 'Ошибка получения данных';